import PropTypes from "prop-types";

export default {
  /**
   * Injected by formik
   **/
  field: PropTypes.shape({
    /**
     * Nombre del input
     */
    name: PropTypes.string,
    /**
     * Valor actual del componente
     */
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number, PropTypes.object, PropTypes.array]),
    /**
     * Callback que se dispara con el cambio del input
     */
    onChange: PropTypes.func,
    /**
     * Callback que se dispara con el cambio de foco
     */
    onBlur: PropTypes.func,
  }),
  /**
   * Injected by formik
   **/
  form: PropTypes.shape({
    /**
     * Objeto con los errores a mostrar por nombre de input del formulario
     */
    errors: PropTypes.object,
    /**
     * Objeto con los inputs del formulario que han sido modificados
     */
    touched: PropTypes.object,
  }),
};
